import * as React from 'react';
import configureStore from '@magoosh/store';
import { Provider } from 'react-redux';
import UserForm from '@magoosh/organisms/signup_form';
import { appendSearchParam, paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';
import { initializeSignupForm } from '@magoosh/organisms/signup_form/actions';
import { SignupFormData } from '@magoosh/act/organisms/signup/types';
import { SubmissionError } from 'redux-form';

export default class SignupForm extends React.Component<SignupFormData> {
  store = configureStore();

  constructor(props) {
    super(props);
    this.store.dispatch(initializeSignupForm(props));
  }

  render() {
    return (
      <Provider store={this.store}>
        <span>
          <strong>Account</strong> {`>`} Payment
        </span>
        <h3>Create an Account</h3>
        <p>
          If you already have an account, <a href={paths.login()}>sign in here</a>.
        </p>
        <UserForm
          onSubmit={this.onSubmitUser}
          initialValues={{ authenticityToken: this.props.authenticityToken }}
          buttonText={'Continue'}
        />
      </Provider>
    );
  }

  onSubmitUser = (values, _dispatch) => {
    return fetch(paths.api.validateUser(), {
      body: JSON.stringify(values),
      method: 'POST'
    })
      .then((response) => {
        window.location.assign(appendSearchParam(window.location, 'step', '2'));
      })
      .catch((response) => {
        throw new SubmissionError(response.errors);
      });
  };
}
